///ready functions
$(document).ready(function () {

    $('#pair-with-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        fade: false, // Disable fade for better mobile experience
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                }
            }
        ]
    });


    // Delay initialization by 1 second (1000 milliseconds)
    setTimeout(function () {
        $('section, .shopify-section, .ingredient-panel').each(function () {
            var element = $(this);
            new Waypoint({
                element: element[0],
                handler: function (direction) {
                    // Action to be triggered when the element comes into view
                    element.addClass('in-view');
                },
                offset: '75%' // Trigger when the element is 75% from the top of the viewport
            });
        });

        $('.svg-wrap').each(function () {
            var element = $(this);
            new Waypoint({
                element: element[0],
                handler: function (direction) {
                    // Action to be triggered when the element comes into view
                    element.addClass('in-view--svg');
                },
                offset: '50%' // Trigger when the element is 50% from the top of the viewport
            });
        });
    }, 1000); // Adjust the delay as needed


    $('.hero-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        asNavFor: '.thumbnail-slider',

        adaptiveHeight: true
    });

    $('#featuredReviewsCarousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        asNavFor: '#featuredReviewsCarouselImage',
        prevArrow: $('.section__featured-reviews #custom-prev-arrow'),
        nextArrow: $('.section__featured-reviews #custom-next-arrow'),
        appendDots: $('.section__featured-reviews #custom-dots-container'),

        adaptiveHeight: true,
        responsive: [

            {
                breakpoint: 768,
                settings: {

                    autoplay: false
                }
            }
        ]
    });
    $('#featuredReviewsCarouselImage').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        asNavFor: '#featuredReviewsCarousel',
        fade: true,
        responsive: [

            {
                breakpoint: 768,
                settings: {

                    autoplay: false
                }
            }
        ]
    });

    $('.featured-reviews-carousel-controls-left').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: $('.section__featured-reviews #custom-prev-arrow'),
        nextArrow: $('.section__featured-reviews #custom-next-arrow'),
        appendDots: $('.section__featured-reviews #custom-dots-container'),

        adaptiveHeight: true,
        responsive: [

            {
                breakpoint: 768,
                settings: {

                    autoplay: false
                }
            }
        ]

    });
    $('#featuredReviewsCarouselFade').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        fade: true,
        prevArrow: $('.section__featured-reviews #custom-prev-arrow'),
        nextArrow: $('.section__featured-reviews #custom-next-arrow'),
        appendDots: $('.section__featured-reviews #custom-dots-container'),

        adaptiveHeight: true,
        responsive: [

            {
                breakpoint: 768,
                settings: {

                    adaptiveHeight: false
                }
            }
        ]

    });

    ////////////////////////////////////// start best sellers ////////////////////////////////////////////////


    // Initialize the slick slider
    $('.best-sellers-card-effect-slick').on('init', function (event, slick) {
        updateFadeOut(slick.currentSlide);
        updateActiveDot(slick.currentSlide);
    });

    $('.best-sellers-card-effect-slick').slick({
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: $('.best-sellers-card-carousel-section #custom-prev-arrow, .best-sellers-card-carousel-section #custom-prev-arrow-mobile'),
        nextArrow: $('.best-sellers-card-carousel-section #custom-next-arrow, .best-sellers-card-carousel-section #custom-next-arrow-mobile'),
        appendDots: $('.best-sellers-card-carousel-section #custom-dots-container, .best-sellers-card-carousel-section #custom-dots-container-mobile'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        updateFadeOut(nextSlide);
    });

    // Append a ghost slide
    var $slickElement = $('.best-sellers-card-effect-slick');
    var $ghostSlide = $('<div class="slick-slide ghost-slide"></div>');
    $slickElement.slick('slickAdd', $ghostSlide);

    $slickElement.on('afterChange', function (event, slick, currentSlide) {
        if (currentSlide === slick.$slides.length - 1) {
            setTimeout(function () {
                $slickElement.slick('slickGoTo', 0);
            }, 500); // Adjust the timeout as needed
        }
        updateActiveDot(currentSlide);
    });

    function updateFadeOut(activeIndex) {
        $('.slick-slide').each(function () {
            var slideIndex = $(this).data('slick-index');
            if (slideIndex < activeIndex) {
                $(this).addClass('fade-out');
            } else {
                $(this).removeClass('fade-out');
            }
        });
    }

    function updateActiveDot(activeIndex) {
        console.log('Updating active dot for index:', activeIndex);
        var isMobile = window.innerWidth <= 576;
        var dotsContainer = isMobile ?
            $('.best-sellers-card-carousel-section #custom-dots-container-mobile .slick-dots') :
            $('.best-sellers-card-carousel-section #custom-dots-container .slick-dots');

        console.log('Dots container:', dotsContainer);
        var dots = dotsContainer.find('li');
        console.log('Dots:', dots);

        dots.removeClass('slick-active');
        dots.eq(activeIndex).addClass('slick-active');
        console.log('Updated active dot:', dots.eq(activeIndex));
    }


    ///////////////////////////////////////////////////// end best sellers ///////////////////////////////////////


    // var currentIndex = 0;
    // var totalCards = $('.card-slide').length;

    // function updateDots() {
    //     $('#custom-dots-container .slick-dots li, #custom-dots-container-mobile .slick-dots li').removeClass('slick-active');
    //     $('#custom-dots-container .slick-dots li').eq(currentIndex).addClass('slick-active');
    // }

    // function updateActiveCard() {
    //     $('.best-sellers-card-effect').attr('data-active-index', currentIndex);
    // }

    // $('.best-sellers-card-carousel-section #custom-next-arrow, .best-sellers-card-carousel-section #custom-next-arrow-mobile').on('click', function () {
    //     if (currentIndex < totalCards - 1) {
    //         currentIndex++;
    //     } else {
    //         currentIndex = 0; // Rewind to the first card
    //     }
    //     updateActiveCard();
    //     updateDots();
    // });

    // $('.best-sellers-card-carousel-section #custom-prev-arrow, .best-sellers-card-carousel-section #custom-prev-arrow-mobile').on('click', function () {
    //     if (currentIndex > 0) {
    //         currentIndex--;
    //     }
    //     updateActiveCard();
    //     updateDots();
    // });

    // // Initial update of dots and active card
    // updateDots();
    // updateActiveCard();

    $('.accordion-vert-overlap.accordion-desktop .custom-accordion-item .custom-accordion-header').click(function () {
        $('.custom-accordion-item').removeClass('overlay--active');


    });

    $('.accordion-vert-overlap.accordion-desktop .custom-accordion-item:first-child .custom-accordion-header').click(function () {
        $('.accordion-wrap').toggleClass('show--1');


        $('.accordion-wrap').removeClass('show--2');
        $('.accordion-wrap').removeClass('show--3');


    });

    $('.accordion-vert-overlap.accordion-desktop .custom-accordion-item:nth-child(2) .custom-accordion-header').click(function () {
        $('.accordion-wrap').toggleClass('show--2');

        $('.accordion-wrap').removeClass('show--3');
        $('.accordion-wrap').removeClass('show--1');


    });
    $('.accordion-vert-overlap.accordion-desktop .custom-accordion-item:nth-child(3) .custom-accordion-header').click(function () {
        $('.accordion-wrap').toggleClass('show--3');

        $('.accordion-wrap').removeClass('show--2');
        $('.accordion-wrap').removeClass('show--1');






    });
    $('.accordion-vert-overlap.accordion-desktop .btn-available-in').click(function () {
        $(this).closest('.custom-accordion-item').addClass('overlay--active');
    });
    $('.accordion-vert-overlap.accordion-desktop .available-in-overlay .btn-close').click(function () {
        $(this).closest('.custom-accordion-item').removeClass('overlay--active');
    });


    $('.all-products-section .products-wrapper').slick({

        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.press-section .press-wrapper').slick({
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: $('.prev-press'),
        nextArrow: $('.next-press'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                }
            }
        ]
    });

    $('.our-features-section.scrollSection .features-wrapper').each(function () {
        $(this).slick({
            infinite: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 3000,
            dots: false,
            variableWidth: true,
            cssEase: 'linear',
            pauseOnFocus: true,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        speed: 3000,
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        speed: 3000,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    });
    $('.product-icon-text .wrapper').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        dots: false,
        cssEase: 'linear',
        pauseOnFocus: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 6000,
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 6000,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            }
        ]
    });

    $('.product .main-product-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        asNavFor: '.product .thumbnails-wrapper',
        prevArrow: $('.product #custom-prev-arrow'),
        nextArrow: $('.product #custom-next-arrow'),
        appendDots: $('.product #custom-dots-container'),

        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }
        ]
    });
    $('.product .thumbnails-wrapper').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product .main-product-wrapper',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true
    });
    $(".image-twinkle-list .btn-hover-arrows").click(function () {
        $(".image-twinkle-list, .image-block-inner").toggleClass('active');
    });
    $(".section__hover-overlay-right .btn-hover-arrows").click(function () {
        $(".section__hover-overlay-right").toggleClass('overlay-in');
    });
    jQuery(".faqs-wrapper .nav-tabs li.active, .product .nav.nav-tabs li.active").click();

    jQuery(".faqs-wrapper .nav-tabs li,.product .nav.nav-tabs li").click(function (e) {
        e.preventDefault();
        jQuery(".faqs-wrapper .nav-tabs li,.product .nav.nav-tabs li").removeClass('active');
        jQuery(this).addClass('active');
        let tid = jQuery(this).find('a').attr('href');
        jQuery('.faqs-wrapper .tab-pane,.product .tab-pane').removeClass('active in');
        jQuery(tid).addClass('active in');

        // Get the data-tab-target value of the clicked tab
        let tabTarget = jQuery(this).find('a').data('tab-target');

        // Show or hide .faq-metaobject-list elements based on the data-tab-show value
        jQuery('.faq-metaobject-list, .faq-nav-wrap .nav-title').each(function () {
            let tabShow = jQuery(this).data('tab-show');
            if (tabTarget === tabShow) {
                jQuery(this).removeClass('d-none').show();
            } else {
                jQuery(this).addClass('d-none').hide();
            }
        });

        // Scroll to the corresponding element based on the data-tab-target value
        let scrollToElement;
        if (tabTarget === 'products') {
            scrollToElement = jQuery('[data-scroll="products"]');
        } else if (tabTarget === 'subscriptions') {
            scrollToElement = jQuery('[data-scroll="subscriptions"]');
        } else if (tabTarget === 'recycling') {
            scrollToElement = jQuery('[data-scroll="recycling"]');
        } else if (tabTarget === 'shipping-returns') {
            scrollToElement = jQuery('[data-scroll="shipping-returns"]');
        }

        if (scrollToElement && scrollToElement.length) {
            jQuery('html, body').animate({
                scrollTop: scrollToElement.offset().top - 200
            }, 500); // Adjust the duration as needed
        }
    });

    $(".btn-filter").click(function () {
        $(".collection-accordion").slideToggle();
        $(this).toggleClass('active');
    });

    // Faqs
    let title = document.querySelectorAll(".faqs-wrapper .faq-item .title-block");

    title.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            //   store the .answer div containing the answer
            let sibling = qsitem.nextElementSibling;

            // Nested loop for removing active class from all and set answer height to 0
            title.forEach((item) => {
                item.nextElementSibling.style.height = "0px";
                //   remove class "active" except for the currently clicked item
                item != qsitem && item.parentNode.classList.remove("active");
            });
            //then toggle the "active" class of clicked item's parent ".qna"
            this.parentNode.classList.toggle("active");

            // set actual height for .answer div if .qna has the class "active"
            if (qsitem.parentNode.classList.contains("active")) {
                sibling.style.height = sibling.scrollHeight + "px";
            } else {
                sibling.style.height = "0px";
            }
        });
    });

    let title_one = document.querySelectorAll(".image-with-accordions .accordion-item .title-block");

    title_one.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            //   store the .answer div containing the answer
            let sibling = qsitem.nextElementSibling;

            // Nested loop for removing active class from all and set answer height to 0
            title_one.forEach((item) => {
                item.nextElementSibling.style.height = "0px";
                //   remove class "active" except for the currently clicked item
                item != qsitem && item.parentNode.classList.remove("active");
            });
            //then toggle the "active" class of clicked item's parent ".qna"
            this.parentNode.classList.toggle("active");

            // set actual height for .answer div if .qna has the class "active"
            if (qsitem.parentNode.classList.contains("active")) {
                sibling.style.height = sibling.scrollHeight + "px";
            } else {
                sibling.style.height = "0px";
            }
        });
    });

    let title_two = document.querySelectorAll(".collection-accordion .accordion-item .title-block");

    title_two.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            //   store the .answer div containing the answer
            let sibling = qsitem.nextElementSibling;

            // Nested loop for removing active class from all and set answer height to 0
            title_two.forEach((item) => {
                item.nextElementSibling.style.height = "0px";
                //   remove class "active" except for the currently clicked item
                item != qsitem && item.parentNode.classList.remove("active");
            });
            //then toggle the "active" class of clicked item's parent ".qna"
            this.parentNode.classList.toggle("active");

            // set actual height for .answer div if .qna has the class "active"
            if (qsitem.parentNode.classList.contains("active")) {
                sibling.style.height = sibling.scrollHeight + "px";
            } else {
                sibling.style.height = "0px";
            }
        });
    });
});

document.querySelectorAll('.footer__links a').forEach(link => {
    link.setAttribute('target', '_blank');
});

document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed");

    // Function to handle class addition
    function handleClassAddition(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                let target = mutation.target;
                let bundlerTargetElement = document.querySelector('.bndlr-products-container');

                console.log("Class attribute changed on", target);

                if (!target.classList.contains('bndlr-hidden')) {
                    bundlerTargetElement.classList.add('active');
                    console.log('Class "active" added to', bundlerTargetElement);
                } else {
                    bundlerTargetElement.classList.remove('active');
                    console.log('Class "active" removed from', bundlerTargetElement);
                }
            }
        }
    }

    // Function to wait for the target element to be available
    function waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
        } else {
            setTimeout(() => waitForElement(selector, callback), 100);
        }
    }

    // Wait for the target element to be available
    waitForElement('.bndlr-mnm-selected-products', function (targetNode) {
        console.log("Target node found:", targetNode);

        // Create an observer instance linked to the callback function
        let observer = new MutationObserver(handleClassAddition);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, { attributes: true });
        console.log("Observer started");
    });

    // old bundle container Add click event listener for .bundle-cta__btn
    //   document.querySelector('.bundle-cta__btn').addEventListener('click', function () {
    //     console.log(".bundle-cta__btn clicked");

    //     const bundlerContainer = document.querySelector('.bundler-target-element');
    //     if (bundlerContainer) {
    //       const offset = 100;
    //       const topPosition = bundlerContainer.getBoundingClientRect().top + window.pageYOffset - offset;
    //       window.scrollTo({
    //         top: topPosition,
    //         behavior: 'smooth'
    //       });
    //     }
    //   });

    // });

    // Add click event listener for .bundle-cta__btn
    // document.querySelector('.bundle-cta__btn').addEventListener('click', function () {
    //   console.log(".bundle-cta__btn clicked");

    //   // Select element with ID containing "bundle_builder_kitenzo"
    //   const bundlerContainer = document.querySelector('[id*="bundle_builder_kitenzo"]');
    //   if (bundlerContainer) {
    //     const offset = 100;
    //     const topPosition = bundlerContainer.getBoundingClientRect().top + window.pageYOffset - offset;
    //     window.scrollTo({
    //       top: topPosition,
    //       behavior: 'smooth'
    //     });
    //   }
    // });

});

document.addEventListener('DOMContentLoaded', function () {
    // Quantity Increment/Decrement Logic
    const decrementButton = document.querySelector('.quantity-btn--decrement');
    const incrementButton = document.querySelector('.quantity-btn--increment');
    const quantityInput = document.getElementById('Quantity');

    if (decrementButton && incrementButton && quantityInput) {
        decrementButton.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default behavior
            const currentValue = parseInt(quantityInput.value, 10) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });

        incrementButton.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default behavior
            const currentValue = parseInt(quantityInput.value, 10) || 1;
            quantityInput.value = currentValue + 1;
        });

        // Prevent invalid manual input
        quantityInput.addEventListener('input', function () {
            if (quantityInput.value < 1) {
                quantityInput.value = 1;
            }
        });
    }

    // Variant Selector Synchronization with Slick Carousel
    const variantSelectors = document.querySelectorAll('.product-selector__dropdown, .product__swatch input[type="radio"]');

    if (variantSelectors.length > 0) {
        variantSelectors.forEach(selector => {
            selector.addEventListener('change', function () {
                const selectedOption = this.options ? this.options[this.selectedIndex] : this;
                const variantImageUrl = selectedOption.getAttribute('data-variant-image-url');

                if (variantImageUrl) {
                    // Find the matching slide by comparing the image URLs
                    $('.main-product-wrapper .slick-slide img').each(function (index, img) {
                        const slideImageUrl = $(img).attr('src').split('?')[0];
                        if (slideImageUrl === variantImageUrl) {
                            $('.main-product-wrapper').slick('slickGoTo', index);
                            return false; // Break the loop
                        }
                    });
                }
            });
        });
    }

    // Hover Behavior for Non-Hover Devices
    if (window.matchMedia('(hover: none)').matches) {
        const hoverInfoElements = document.querySelectorAll('.card-product.hover-image__hover-info');

        hoverInfoElements.forEach(element => {
            element.addEventListener('click', function (event) {
                if (!element.classList.contains('hover-in')) {
                    event.preventDefault();
                    element.classList.add('hover-in');
                }
            });
        });
    }
});




document.addEventListener('DOMContentLoaded', function () {
    var accordion = document.getElementById('accordionControls');
    var imgWrap = document.querySelector('.section__accordion-carousel .img-wrap');

    if (!accordion || !imgWrap) {
        console.error('Accordion or imgWrap not found');
        return;
    }

    accordion.addEventListener('show.bs.collapse', function (event) {
        var openAccordionTarget = event.target.id;
        console.log('Accordion opened:', openAccordionTarget);
        imgWrap.className = 'img-wrap'; // Reset class
        imgWrap.classList.add(openAccordionTarget);
    });

    // Initial setup for the first open accordion
    var initialOpenAccordion = document.querySelector('.accordion-collapse.show');
    if (initialOpenAccordion) {
        var initialOpenAccordionTarget = initialOpenAccordion.id;
        console.log('Initial open accordion:', initialOpenAccordionTarget);
        imgWrap.classList.add(initialOpenAccordionTarget);
    }
});

// document.addEventListener('DOMContentLoaded', function () {
//     var emailSelect = document.getElementById('contact-email-select');
//     var emailHidden = document.getElementById('contact-email-hidden');

//     // Set the initial value
//     emailHidden.value = emailSelect.value;

//     // Update the hidden input value when the dropdown changes
//     emailSelect.addEventListener('change', function () {
//         emailHidden.value = emailSelect.value;
//     });
// });

// document.querySelectorAll('.card-product__sizes-btn').forEach(button => {
//   button.addEventListener('click', function () {
//     document.getElementById('cart-drawer').classList.add('is-visible');
//   });
// });




document.querySelectorAll('.cart-drawer__close').forEach(button => {
    button.addEventListener('click', function () {
        document.getElementById('cart-drawer').classList.remove('is-visible');
    });
});

jQuery(document).ready(function ($) {
    $('.has-sub-dropdown > a').click(function (e) {
        e.preventDefault();

        // Toggle 'active' class on the parent .header__nav-links
        $(this).closest('.header__nav-links li').toggleClass('active');

        // Toggle 'active' class on the child .header__sub-nav
        $(this).siblings('.header__sub-nav').toggleClass('active');
    });

    // Allow sub-navigation links to work correctly
    $('.header__sub-nav a').click(function (e) {
        e.stopPropagation(); // Prevent the click event from bubbling up
    });
});


// document.addEventListener('DOMContentLoaded', function () {
//   const addToCartButtons = document.querySelectorAll('.card-product__sizes-btn');
//   if (addToCartButtons.length > 0) {
//     addToCartButtons.forEach(button => {
//       button.addEventListener('click', function () {
//         const variantId = this.getAttribute('data-variantid');
//         addToCart(variantId);
//       });
//     });
//   } else {
//     console.error('No add to cart buttons found');
//   }
// });

// function addToCart(variantId) {
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: 1
//     })
//   })
//     .then(response => response.json())
//     .then(data => {
//       console.log('Item added to cart:', data);
//       // Trigger custom event
//       const event = new CustomEvent('product_added_to_cart', { detail: data });
//       document.dispatchEvent(event);
//       // Update cart drawer or show success message
//       document.querySelector('.js-success-message').classList.remove('hidden');
//     })
//     .catch(error => {
//       console.error('Error adding item to cart:', error);
//       // Show error message
//       document.querySelector('.js-error-message').classList.remove('hidden');
//     });
// }




document.addEventListener('DOMContentLoaded', function () {
    // Check if the device does not support hover
    if (window.matchMedia('(hover: none)').matches) {
        // Select all elements with the class 'card-product.hover-image__hover-info'
        const hoverInfoElements = document.querySelectorAll('.card-product.hover-image__hover-info');

        hoverInfoElements.forEach(element => {
            element.addEventListener('click', function (event) {
                // Check if the element already has the 'hover-in' class
                if (!element.classList.contains('hover-in')) {
                    // Prevent the default action
                    event.preventDefault();
                    // Add the 'hover-in' class
                    element.classList.add('hover-in');
                }
            });
        });
    }
});
document.addEventListener('DOMContentLoaded', function () {
    // Check if the device does not support hover
    if (window.matchMedia('(hover: none)').matches) {
        // Select all elements with the class '.artwork-item__hover-panel'
        const hoverArtworkElements = document.querySelectorAll('.artwork-item.hover-assigned');

        hoverArtworkElements.forEach(element => {
            element.addEventListener('click', function (event) {
                // Check if the element already has the 'hover-in' class
                if (!element.classList.contains('hover-in')) {
                    // Prevent the default action
                    event.preventDefault();
                    // Add the 'hover-in' class
                    element.classList.add('hover-in');
                }
            });
        });
    }
});

// document.addEventListener('DOMContentLoaded', function () {
//     var header = document.querySelector('#header'); // Replace with your header selector
//     var lastScrollTop = 0;
//     var headerHeight = Math.max(window.innerHeight, 480); // Use the larger value between 100vh and 480px

//     if (header && header.classList.contains('is-sticky')) {
//         window.addEventListener('scroll', function () {
//             var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//             if (scrollTop > 100) {
//                 header.classList.add('is-sticky-fixed');
//             } else {
//                 header.classList.remove('is-sticky-fixed');
//             }

//             if (scrollTop > headerHeight) {
//                 if (scrollTop < lastScrollTop) {
//                     // Scrolling up
//                     header.classList.add('is-sticky--on');
//                 } else {
//                     // Scrolling down
//                     header.classList.remove('is-sticky--on');
//                 }
//             } else {
//                 header.classList.remove('is-sticky--on');
//             }

//             lastScrollTop = scrollTop;
//         });
//     }
// });



